import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { AlertController, ModalController, ViewController, NavParams, Slides } from 'ionic-angular';
import { CalendarModal } from 'ion2-calendar';
import { MeteorObservable } from 'meteor-rxjs';
import * as moment from 'moment';
import { conformToMask } from 'angular2-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
// import { getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { HttpService } from '../../services/httpService';
import { SelectProjectManagerComponent } from '../select-project-manager/select-project-manager';
import { App } from "ionic-angular";

import { Company, User } from 'api/models';
import { ISDEV, APP_TITLE } from "../../services/config";

function zipCodeValidator() {
  const usZipRegex = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/);
  return (control: AbstractControl): {
    [key: string]: any } => {
    const validInput = control.value ? usZipRegex.test(control.value) : true;
    return validInput ? null : { 'zipCode': { value: control.value } };
  };
}

function phoneNumberValidator() {
  const usZipRegex = new RegExp(/^[0-9()\s-\+]+$/);
  return (control: AbstractControl): {
    [key: string]: any } => {
    const validInput = control.value ? usZipRegex.test(control.value) : true;
    return validInput ? null : { 'phoneNumber': { value: control.value } };
  };
}
@Component({
  selector: 'new-project',
  templateUrl: 'new-project.html'
})
export class NewProjectComponent implements OnInit {
  @ViewChild(Slides) slides: Slides;
  public isDev = ISDEV;
  company: Company | void;
  companyId: string = '';
  lastProjectName: string = '';
  phoneMask: Array < string | RegExp > ;
  zipMask: Array < string | RegExp > ;
  dollarMask: { mask: (str: string) => Array < string | RegExp > };
  constructionTypeOptions: Array < string > ;
  constructionTypeConfig: Object;
  projectManager: User | void;

  generalProjectInfoForm: FormGroup;
  contractualDatesForm: FormGroup;
  siteLocationForm: FormGroup;

  isFirstSlide: boolean = true;
  isLastSlide: boolean = false;
  skipLocationForm: boolean = false;

  constructor(
    private _app: App,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private navParams: NavParams,
    public modalCtrl: ModalController,
    public httpService: HttpService,
    public companyService: CompanyService
  ) {
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    this.dollarMask = {
      mask: createNumberMask({
        prefix: '$',
        includeThousandsSeparator: true,
        allowDecimal: true,
        decimalLimit: 2,
        integerLimit: null, // unlimited
        requireDecimal: false,
      }),
    };
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
    if(this.isDev == true) { console.log('new project page') }
    this.companyId = this.navParams.get('companyId');
    this.constructionTypeConfig = {
      title: 'Select Construction Type',
      cssClass: 'coloredHeader',
    };
    MeteorObservable.autorun().subscribe(() => {
      if(this.companyId) {
        this.company = this.companyService.getCompany(this.companyId);
      }
    });
    this.generalProjectInfoForm = new FormGroup({
      'name': new FormControl('', [Validators.required]),
      'ntpDate': new FormControl(null),
      'contractCompletionDate': new FormControl(null),
    });
  }

  eventHandler(keyCode) {
      if(keyCode == 13) {
        let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }

  editProjectManager() {
    if (!this.company) {
      return;
    }
    const modal = this.modalCtrl.create(SelectProjectManagerComponent, {companyId: this.company._id}, {enableBackdropDismiss: false});
    modal.present();
    modal.onDidDismiss((selectedUser) => {
      if (selectedUser) {
        this.projectManager = selectedUser;
      }
    });
  }

  slideChanged() {
    this.isFirstSlide = this.slides.isBeginning();
    this.isLastSlide = this.slides.isEnd();
  }

  canGoToNextSlide() {
    const index = this.slides.getActiveIndex();
    if (index === 0) { // General Project Info
      if (this.generalProjectInfoForm.status === 'VALID' && this.projectManager) {
        return true;
      }
    }
  }


  goToSlideNext() {
    this.slides.slideNext();
  }

  goToSlidePrevious() {
    this.slides.slidePrev();
  }

  formatDollar(dollarStr: void|string): string {
    return conformToMask(dollarStr || '', this.dollarMask.mask(dollarStr || ''), {guide:false}).conformedValue;
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }

  presentNTPDateModal(): void {
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Notice To Proceed',
        pickMode: 'single',
        canBackwardsSelected: true,
      },
    });

    myCalendar.onDidDismiss((date, type) => {
      if (type === 'cancel') {
        return
      }
      this.generalProjectInfoForm.patchValue({
        ntpDate: date ? new Date(date.time) : undefined,
      });
    });

    myCalendar.present();
  }

  presentCCDModal(): void {
    const ntpMoment = moment(this.generalProjectInfoForm.controls.ntpDate.value)
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Contract Completion',
        pickMode: 'single',
        from: ntpMoment.clone().add(24, 'hours').toDate(),
        daysConfig: [{
          date: ntpMoment.toDate(),
          subTitle: 'NTP',
        }],
      },
    });

    myCalendar.onDidDismiss((date, type) => {
      if (type === 'cancel') {
        return;
      }
      this.generalProjectInfoForm.patchValue({
        contractCompletionDate: date ? new Date(date.time) : undefined,
      });
    });

    myCalendar.present();
  }

  submitNewProjectForm(): void {
    const newProjectInput = {
      ...this.generalProjectInfoForm.value,
    };
    if(this.isDev == true) { console.log("newProjectInput", newProjectInput) }
    if(this.isDev == true) {  console.log("this.lastProjectName", this.lastProjectName, newProjectInput.name) }
    if (!newProjectInput.name || !newProjectInput.name.length) {
      return;
    }
    if(this.lastProjectName===newProjectInput.name){
      return;
    }
    this.lastProjectName=newProjectInput.name;

    /*
    MeteorObservable.call('createNewProject', {
      companyId: this.companyId,
      newProjectInput,
      projectManagerId: this.projectManager && this.projectManager._id,
    }).subscribe({
      next: () => {
        this.lastProjectName = '';
        this.viewCtrl.dismiss();
      },
      error: (err: Error) => {
        this.handleError(err);
      }
    });
    */
    this.httpService.MeteorCall('createNewProject', {
      companyId: this.companyId,
      newProjectInput,
      projectManagerId: this.projectManager && this.projectManager._id,
    }).then(() => {
      this.lastProjectName = '';
      this.viewCtrl.dismiss();
    })
    .catch((e: Error) => {
      this.handleError(e);
    });
  }

  handleError(err: Error): void {
    if(this.isDev == true) { console.error('NewProject Error', err) }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: (err as any).reason === 'Match failed' ? 'Incomplete or Invalid form' : err.message,
      title: 'Oops!'
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/new-project/new-project.ts